var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-carousel"},[_c('CtaHeading',{attrs:{"title":_vm.title,"level":2,"link":_vm.link,"linkText":_vm.linkText}}),_vm._v(" "),_c('AgCarousel',{staticClass:"carousel",attrs:{"settings":{
            peek: 0,
            gap: 16,
            perView: 5,
            breakpoints: {
                1359: { peek: 0, perView: 4 },
                991: { peek: 0, perView: 3 },
                767: { peek: 0, perView: 3 },
                450: {
                    perView: 1,
                    peek: {
                        before: 0,
                        after: 150,
                    },
                },
            },
        },"count":_vm.imagesCount}},_vm._l((_vm.transformedImages),function(image,index){return _c('SfCarouselItem',{key:index,staticClass:"carousel__item"},[_c('div',[_c('figure',{staticClass:"image-carousel--item"},[_c('nuxt-img',{staticClass:"image-carousel--item__img",attrs:{"src":image.image,"fit":"cover","loading":"lazy","placeholder":[233, 320, 10]}}),_vm._v(" "),(image.caption)?_c('caption',{staticClass:"image-carousel--item__caption"},[_vm._v("\n                        "+_vm._s(image.caption)+"\n                    ")]):_vm._e(),_vm._v(" "),(image.link)?_c('nuxt-link',{staticClass:"image-carousel--item__link",attrs:{"to":image.link,"title":image.caption}}):_vm._e()],1)])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }